import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-field-wrapper',
  templateUrl: './field-wrapper.component.html',
  styleUrls: ['./field-wrapper.component.scss']
})
export class FieldWrapperComponent extends FieldWrapper {
  hasErrors(): boolean {
    return this.formControl?.touched
            && (this.formControl?.errors !== null
            && Object.keys(this.formControl?.errors).length > 0);
  }

  errorMessages(): string[] {
    // We want to iterate through the form control errors which is an object of { key: object }.
    // Most validations will be in the format of key: boolean or key: object. We will filter out any entry
    // which has a value of false or undefined/null and then map all the validation keys to the custom messages.
    //@ts-ignore
    return Object.entries(this.formControl.errors)
        .filter(entry => entry[1])
        .map(entry => this.getMessage(entry[0]))
  }

  private getMessage(key: String): string {
    switch (key){
      case "required":
        return `${this.getFieldNameOrThis()} is required`;
      case "email":
        return `${this.getFieldNameOrThis()} must be a valid email`;
      case "minlength":
        return `${this.getFieldNameOrThis()} is under the ${this.field.props?.["minlength"]} character limit`;
      case "maxlength":
        return `${this.getFieldNameOrThis()} is over the ${this.field.props?.["maxlength"]} character limit`;
      case "pattern":
        return this.getPatternMessage();
      case "addressInvalid":
        return `${this.getFieldNameOrThis()} is required`;
      case "mustBeNumeric":
        return `${this.getFieldNameOrThis()} must be numeric`;
      case "cvvLength":
        return `${this.getFieldNameOrThis()} should be between 2 to 4 characters in length`;
      case "mustMatchAccountNumbers":
        return "Account Numbers must match";
      default:
        return "";
    }
  }

  private getFieldNameOrThis(): string {
    return this.field.props?.label || 'This';
  }

  private getPatternMessage(): string {
    if (this.field.props?.['decimal']) {
      return `${this.getFieldNameOrThis()} must be a valid number with no more than ${this.getDigitsAfterDecimal()}`;
    } else {
      return `${this.getFieldNameOrThis()} must be a whole number`;
    }
  }

  private getDigitsAfterDecimal(): string {
    switch (this.field.props?.['digitsAfterDecimal']) {
      case 1:
        return "one decimal";
      case 2:
        return "two decimals";
      case 3:
        return "three decimals";
      default:
        return `${this.field.props?.['digitsAfterDecimal']} decimals`
    }
  }
}
